module.exports = __webpack_public_path__ + "static/media/slider1-2.a0f6af1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Home/slider1-2.jpg
// module id = 476
// module chunks = 0